import appInfo from "@common/appInfo";
import { type RichEditorToolbarButtons, type RichEditorToolbarMenu } from "@common/components/Inputs/RichEditor/types";
import { IconType } from "@common/declarations";

export type RichEditorToolbar = "none" | "basic" | "extended" | "default";

export const TOOLBAR_STYLE: RichEditorToolbarMenu = {
  icon: IconType.TextSize,
  items: ["p", "h1", "h2", "h3", "h4", "h5", "h6"]
};

export const BASIC_TOOLBAR: RichEditorToolbarButtons = ["bold", "italic", "underline", "forecolor"];

export const EXTENDED_TOOLBAR: RichEditorToolbarButtons = ["bold", "italic", "underline", TOOLBAR_STYLE, "a"];

export const DEFAULT_TOOLBAR: RichEditorToolbarButtons = [
  TOOLBAR_STYLE,
  "bold",
  "italic",
  "underline",
  "ul",
  "ol",
  "forecolor",
  "a",
  "codeview"
];

const EMPTY_TOOLBAR = [];

const TOOLBARS = {
  ["basic"]: BASIC_TOOLBAR,
  ["default"]: DEFAULT_TOOLBAR,
  ["extended"]: EXTENDED_TOOLBAR,
  ["none"]: EMPTY_TOOLBAR
};
export const getToolbar = (type: string | undefined, isAdmin: boolean): RichEditorToolbarButtons => {
  const toolbar = type ? TOOLBARS[type] : DEFAULT_TOOLBAR;
  if (appInfo.ai.isTextGenerationEnabled && isAdmin) {
    return ["ai", ...toolbar];
  }

  return toolbar;
};
